import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMap } from 'react-leaflet';
import { setNeedBounding, setCenter, setZoom, findLatLngSelector } from '../../../features/map/mapSlice';



const OsmFindLatLngBounder = () => {
    const map = useMap();
    const dispatch = useDispatch();
    const markerData = useSelector(findLatLngSelector);

    useEffect(() => {
        const mapBounder = () => {
            if (map && markerData) {
                dispatch(setCenter({
                    lat: parseFloat(markerData.lat),
                    lng: parseFloat(markerData.lng),
                }));
                dispatch(setZoom(14));
                dispatch(setNeedBounding(false));
            };
        };
        mapBounder();
    }, [dispatch, map, markerData]);

    return (
        <div></div>
    );
}

export default OsmFindLatLngBounder